import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Character,
} from "@dndModels";

import API from "@utilities/smart_api";
import CommonUtilities from "@utilities/common_utilities";

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import CenteredMenu from "@components/input/menus/CenteredMenu";

import CharacterCharacteristicInput from "@dndComponents/character/features/CharacterCharacteristicInput";

interface Props {
  character: Character;
}

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function CharacterDescription({
  character,
}: Props) {
  const [view, setView] = useState("ALL");
  const [base_size, setBaseSize] = useState(character.base_size);
  const [characteristics, setCharacteristics] = useState(character.notes.characteristics);

  const renderCharacteristicFeatures = () => {
    // if (view === "ALL") {
    //   return character.characteristic_feature_source_names.map(source_name => {
    //     return renderCharacteristicFeaturesForSourceName(source_name);
    //   });
    // } else if (character.characteristic_feature_source_names.includes(view)) {
    //   return renderCharacteristicFeaturesForSourceName(view);
    // }
    return null;
  }

  // const renderCharacteristicFeaturesForSourceName = (source_name: string) => {
  //   const characteristic_features = character.characteristic_features;
  //   const header = 
  //     <Grid
  //       key={`${source_name}_header`}
  //       style={{ fontWeight: "bold", fontSize: "12px" }}>
  //       { source_name }
  //     </Grid>;
  //   const return_us = characteristic_features.filter(o => o.source_name === source_name).map((cf, key) => {
  //     return (
  //       <CharacterCharacteristicInput key={`${source_name}_${key}`}
  //         character={character}
  //         char_feature={cf}
  //         // value={cf.feature_options[0]}
  //         onChange={(changed: string) => {
  //           cf.feature_options[0] = changed;
  //           character.changed();
  //         }}
  //       />
  //     );
  //   });
  //   return [header,...return_us];
  // }

  const updateCharacteristic = (key: string, changed: string) => {
    const new_characteristics = {...characteristics};
    new_characteristics[key] = changed;
    setCharacteristics(new_characteristics);
    character.notes.characteristics = new_characteristics;
    character.changed();
  }
  
  const enabled = api.user && (character.owner_id === api.user._id || (character.campaign && character.campaign.owner_id === api.user._id));
  // const menu_options = ["ALL","Characteristics","Appearance",...character.characteristic_feature_source_names];
  return (
    <Grid container spacing={0} direction="row"
      className="curved_border bg_black_transp"
      style={{
        fontSize: "11px"
      }}>
      {/* <Grid size={12}>
        <div className="centered">
          <CenteredMenu
            options={menu_options}
            selected={view}
            onSelect={setView}
          />
        </div>
      </Grid> */}
      { (view === "ALL" || view === "Characteristics") && 
        <>
          <Grid size={12} style={{ fontWeight: "bold", fontSize: "12px" }}>
            Characteristics
          </Grid>
          { character.spirit.race.source && 
            <>
              <Grid size={12}>
                <span style={{ fontWeight: "bold" }}>Creature Type: { character.spirit.race.source.creature_type }</span>
              </Grid>
              <Grid size={12}>
                { character.spirit.race.source.sizes.length === 1 ?
                  <span style={{ fontWeight: "bold" }}>Size: { common_util.size_map[base_size] }</span>
                :
                  <SelectStringBox 
                    name="Size"
                    options={common_util.get_size_strings(character.spirit.race.source.sizes)}
                    value={common_util.size_map[base_size]} 
                    disabled={ !enabled }
                    onChange={(value: string) => {
                      const new_base_size = common_util.size_to_num_map[value];
                      setBaseSize(new_base_size);
                      character.spirit.base_size = new_base_size;
                      character.changed();
                    }}
                  />
                }
              </Grid>
            </>
          }
          <Grid size={12}>
            <StringBox
              name="Faith"
              disabled={ !enabled }
              value={characteristics.faith}
              onBlur={(changed: string) => {
                updateCharacteristic("faith", changed);
              }}
            />
          </Grid>
          <Grid size={12}>
            <SelectStringBox
              name="Alignment"
              disabled={ !enabled }
              options={["Lawful Good","Lawful Neutral","Lawful Evil","Neutral Good","Neutral","Neutral Evil","Chaotic Good","Chaotic Neutral","Chaotic Evil"]}
              value={characteristics.alignment}
              onChange={(changed: string) => {
                updateCharacteristic("alignment", changed);
              }}
            />
          </Grid>
          <Grid size={12}>
            <SelectStringBox
              name="Lifestyle"
              disabled={ !enabled }
              options={["Wretched","Squalid (1 SP)","Poor (2 SP)","Modest (1 GP)","Comfortable (2 GP)","Wealthy (4 GP)","Aristocratic (10 GP Min)"]}
              value={characteristics.lifestyle}
              onChange={(changed: string) => {
                updateCharacteristic("lifestyle", changed);
              }}
            />
          </Grid>
          <Grid size={12}>
            <StringBox
              name="Hair"
              disabled={ !enabled }
              value={characteristics.hair}
              onBlur={(changed: string) => {
                updateCharacteristic("hair", changed);
              }}
            />
          </Grid>
          <Grid size={12}>
            <StringBox
              name="Skin"
              disabled={ !enabled }
              value={characteristics.skin}
              onBlur={(changed: string) => {
                updateCharacteristic("skin", changed);
              }}
            />
          </Grid>
          <Grid size={12}>
            <StringBox
              name="Eyes"
              disabled={ !enabled }
              value={characteristics.eyes}
              onBlur={(changed: string) => {
                updateCharacteristic("eyes", changed);
              }}
            />
          </Grid>
          <Grid size={12}>
            <StringBox
              name="Height"
              disabled={ !enabled }
              value={characteristics.height}
              onBlur={(changed: string) => {
                updateCharacteristic("height", changed);
              }}
            />
          </Grid>
          <Grid size={12}>
            <StringBox
              name="Weight (lbs)"
              disabled={ !enabled }
              value={characteristics.weight}
              type="number"
              onBlur={(changed: string) => {
                updateCharacteristic("weight", changed);
              }}
            />
          </Grid>
          <Grid size={12}>
            <StringBox
              name="Age (Years)"
              disabled={ !enabled }
              value={characteristics.age}
              type="number"
              onBlur={(changed: string) => {
                updateCharacteristic("age", changed);
              }}
            />
          </Grid>
          <Grid size={12}>
            <StringBox
              name="Gender"
              disabled={ !enabled }
              value={characteristics.gender}
              onBlur={(changed: string) => {
                updateCharacteristic("gender", changed);
              }}
            />
          </Grid>
        </>
      }
      { (view === "ALL" || view === "Appearance") && 
        <>
          <Grid size={12} style={{ fontWeight: "bold", fontSize: "12px" }}>
            Appearance
          </Grid>
          <Grid size={12}>
            <StringBox 
              name="Appearance" 
              disabled={ !enabled }
              value={characteristics.appearance} 
              multiline
              onBlur={(changed: string) => {
                updateCharacteristic("appearance", changed);
              }}
            />
          </Grid>
        </>
      }
      { renderCharacteristicFeatures() }
    </Grid>
  );
}
